<template lang="en">
<div>
    <BaseModal :config="PartnerModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
        <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
            <form>
                <div id="error" class="alert alert-danger" role="alert" v-if="displayError" v-show="errors.items.length">
                    <!-- <span v-show="errors.has('PartnerID')" class="alert-danger">
              {{ errors.first('PartnerID') }} -->
              <br>
            </span>
                </div>
                <div id="Customerror" class="alert alert-danger" role="alert" v-show="customerrors.length && !errors.items.length">
                    <span v-show="customerrors.length" class="alert-danger">
             <b>Please correct the following error(s):</b>
            <ul>
            <li v-for="error in customerrors" :key=error>{{ error }}</li>
            </ul>
            </span>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="PartnerID">Partner ID</label>
                        <input type="text" class="form-control" id="PartnerID"  name="PartnerID" placeholder="Partner ID" 
                      
                        v-model="PartnerInfoFormConfig.PartnerId">
            </div>
                        <div class="form-group col-md-6">
                            <label for="DateIssued">Date Issued</label>

                            <div class="input-group ">
                <kendo-datepicker
                      placeholder="Select Date"  
                      :value='PartnerInfoFormConfig.DateIssued'
                      v-model='PartnerInfoFormConfig.DateIssued'
                       :format="'MM/dd/yyyy'" 
                       id="dtIssued"
		                width="100%"   
                        @open="_setCurrentDateifNull"
                        >
                       </kendo-datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="PartnerName">Partner Name</label>
                            <input type="text" class="form-control" id="PartnerName" placeholder="Partner Name" v-model="PartnerInfoFormConfig.PartnerName">

                            </div>
                            <div class="form-group col-md-6">
                                <label for="TSDocumentID">T.S Document ID</label>
                                <input type="text" class="form-control" id="TSDocumentID" v-model="PartnerInfoFormConfig.TSDocumentID">
                            </div>
                            </div>

                            <div class="form-row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class=" form-group col-md-12" style="padding-right:15px !important;">
                                            <label for="UnitClass">Unit Class</label>
                                            <!-- <input type="text" class="form-control" id="PartnerID" placeholder="Unit Class Type" v-model="PartnerInfoFormConfig.UnitClassType"> -->
                                            <div id="kendo-select">
                <kendo-dropdownlist v-model="PartnerInfoFormConfig.UnitClass"
                            :data-source="PartnerUnitClassOptions"
                            :data-text-field="'value'"
                            :data-value-field="'value'">
                </kendo-dropdownlist>   
              </div>
                                        </div>
                                        <div class="form-group col-md-12" style="padding-right:15px !important;">
                                            <label for="Units">Units</label>
                                            <input type="text" class="form-control" id="Units" v-model="PartnerInfoFormConfig.Units">
                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6" style="padding-left:7.5px !important;">
                                        <label for="Notes">Notes</label>
                                        <textarea class="form-control" rows="4" cols="50" id="Notes" placeholder="Test Notes" v-model="PartnerInfoFormConfig.Notes"></textarea>

                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="NewTreasury">New Treasury</label>
                                        <select id="NewTreasury" class="form-control">
                                    <option selected>Choose...</option>
                                    <option>...</option>
                                    </select>
                                        <br>
                                        <br>
                                        <br>
                                    </div>
                                    </div>

            </form>
        </div>
    </BaseModal>
</div>
</template>

<script>
/* eslint-disable vue/consistent-return */
/* eslint-disable */
import $ from 'jquery';
import BaseModal from "@/components/base/BaseModal.vue";
import moment from "moment";
import funcUtil from "@/services/funcUtil.js";
export default {
    name: "PartnerInfoForm",
    props: ["PartnerInfoFormConfig", "PartnerModalLabel", "PartnerUnitClassOptions"],
    mixins:[funcUtil],
    data: function () {
        return {
            displayError: false,
            customerrors: []

        }
    },
    components: {
        BaseModal
    },
    methods: {
        saveChanges: function (e) {
            let self = this;
            this.displayError = true;
            this.$validator.validate().then(result => {
                if (result && self.checkUnits()) {
                    if (this.PartnerModalLabel.modalAddorEdit == "add") {
                        // Add Popup
                        console.log(JSON.stringify(this.PartnerInfoFormConfig));

                    } else {
                        // Edit Popup
                        console.log(JSON.stringify(this.PartnerInfoFormConfig));
                        this.PartnerInfoFormConfig.DateIssued = moment(
                            this.PartnerInfoFormConfig.DateIssued
                        ).format("MM/DD/YYYY");
                        this.$emit("UpdateParentGrid", e);

                    }
                    //alert("Data is saved in console");
                    $("#BaseModal").modal("toggle");
                    this.resetFields();
                }
            });
        },
        checkUnits: function () {
            this.customerrors = [];
            if (!this.isNotNegative) {
                this.customerrors.push('Units should be positive.');
            }
            if (!this.customerrors.length) {
                return true;
            }
        },
        resetFields: function () {
            this.displayError = false;
            this.errors.clear();
            this.customerrors = [];
            //Object.assign(this.$data, this.$options.data.call(this));

        }
    },
    computed: {
        isNotNegative: function () {
            debugger;
            if (this.PartnerInfoFormConfig.Units) {
                return this.PartnerInfoFormConfig.Units > 0;
            }

        }
    }
}
</script>

<style>
.mx-input {
    height: calc(2.25rem + 2px) !important;
}
</style>
